import { EntityState } from '@reduxjs/toolkit';
import { AuthAdapter, AuthState } from '@store/auth/auth.slice';

export const AuthSelector = AuthAdapter.getSelectors(
  (state) => state as EntityState<AuthState>,
);
